import { LinearProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { Suspense, useState } from 'react';
import { renderRoutes } from 'react-router-config';
import NavBar from './NavBar';
import TopBar from './TopBar';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles(theme => ({
  container: {
    // minHeight: '100vh',
    display: 'flex',
    '@media all and (-ms-high-contrast:none)': {
      height: 0 // IE11 fix
    }
  },
  content: {
    paddingTop: 10,
    flexGrow: 1,
    maxWidth: '100%',
    maxHeight: '100%',
    overflowX: 'hidden',
    overflowY: 'hidden',
    [theme.breakpoints.down('xs')]: {
      paddingTop: 1
    }
  }
}));

function Dashboard({ route }) {
  const classes = useStyles();
  const SessionUser = getUser();
  const initialOpenNavBar = SessionUser?.ServiceShopTypeId === 15 && SessionUser?.TenantId == 118;
  const [openNavBar, setOpenNavBar] = useState(initialOpenNavBar);

  console.log('Dashboard route:', route);

  return (
    <>
      <TopBar
        onOpenNavBar={() => setOpenNavBar(!openNavBar)}
      />
      <NavBar onClose={() => setOpenNavBar(!openNavBar)} open={openNavBar} />
      <div className={classes.container}>
        <div
          className={classes.content}
          style={{ paddingLeft: openNavBar ? 256 : 0 }}
        >
          <Suspense fallback={<LinearProgress />}>
            {renderRoutes(route.routes)}
          </Suspense>
        </div>
      </div>
    </>
  );
}

Dashboard.propTypes = {
  route: PropTypes.object
};

export default Dashboard;
